import { MonthName } from "@/app/reports/utils/enums";

const getMonthColumns = (date) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, month] = date?.split("-");
  const columns = [];

  for (let i = 1; i <= 31; i++) {
    const dayNumber = String(i).padStart(2, "0");

    const dayColumn = {
      title: `${MonthName[month]}-${dayNumber}`,
      dataIndex: dayNumber,
      key: dayNumber,
      width: 100,
      slots: { customRender: "dayContent" },
    };

    columns.push(dayColumn);
  }

  return columns;
};

export const getDailyManagementColumns = (date, { byUser = false } = {}) => {
  const title = byUser ? "Usuario" : "Descripción";
  const key = byUser ? "usuario" : "description";

  return [
    {
      title: title,
      dataIndex: key,
      key,
      width: 200,
      ellipsis: true,
      fixed: "left",
    },
    ...getMonthColumns(date),
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      width: 140,
      fixed: "right",
      slots: { customRender: "totalContent" },
    },
  ];
};
